import axios from "axios";

// Custom Component
// import DoRefreshToken from '../components/SignIn/DoRefreshToken'
import SignOut from "../components/SignIn/SignOut";

const store = require("store");

const getCirculation = async () => {
  const getCirculation_api = "/circulation";
  let result;

  // const search = searchKey ? "?code=" + searchKey.code + "&sname=" + searchKey.sname + "&subject=" + searchKey.subject + "&sdfrom=" + searchKey.sdfrom + "&sdto=" + searchKey.sdto : ""
  // const search = searchKey ? "?code=" + searchKey.code + "&sname=" + searchKey.sname + "&subject=" + searchKey.subject + "&sdfrom=" + searchKey.sdfrom + "&sdto=" + searchKey.sdto + "&lrname=" + searchKey.lrname + "&lrdfrom=" + searchKey.lrdfrom + "&lrdto=" + searchKey.lrdto : ""

  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "get",
      url: process.env.REACT_APP_API_URL_3006 + getCirculation_api,
      headers: headers,
    });

    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const getCirculationDetail = async (circSeq) => {
  const getCirculationDetail_api = `/circulation/${circSeq}`;
  let result;

  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "get",
      url: process.env.REACT_APP_API_URL_3006 + getCirculationDetail_api,
      headers: headers,
    });

    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const recallCirculation = async (circSeq) => {
  const getCirculationDetail_api = `/circulation/${circSeq}/recall`;
  let result;

  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "post",
      url: process.env.REACT_APP_API_URL_3006 + getCirculationDetail_api,
      headers: headers,
      data: {},
    });

    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const setCirculationReaded = async (circSeq) => {
  const setCirculationReaded_api = `/circulation/${circSeq}/read`;
  let result;

  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "post",
      url: process.env.REACT_APP_API_URL_3006 + setCirculationReaded_api,
      headers: headers,
    });

    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const getUser = async (userType) => {
  const getUser_api = "/siteuser";
  let params;
  let result;

  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    const data =
      userType === "ALL"
        ? { status: true }
        : userType
        ? { status: true, is_internal: true }
        : { status: true, is_internal: false };

    // const data = {
    // 	status: true,
    // 	is_internal: true
    // }

    params = data;

    result = await axios({
      method: "get",
      url: process.env.REACT_APP_API_URL_3001 + getUser_api,
      headers: headers,
      params: params,
    });

    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const getUserGroupType = async () => {
  // const getUserGroupType_api = "/usergroup/ui/type"
  const getUserGroupType_api = "/usergroup/ui/type/listing";
  let result;

  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "get",
      url: process.env.REACT_APP_API_URL_3007 + getUserGroupType_api,
      headers: headers,
    });

    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const getUserGroup = async (typeSeq = "") => {
  const getUserGroup_api = "/usergroup";
  let params;
  let result;

  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    const data = {
      type: typeSeq,
    };

    params = data;

    result = await axios({
      method: "get",
      url: process.env.REACT_APP_API_URL_3007 + getUserGroup_api,
      headers: headers,
      params: params,
    });

    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const getForwardData = async (circSeq) => {
  const getForwardData_api = `/circulation/${circSeq}/forward`;
  let result;

  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "get",
      url: process.env.REACT_APP_API_URL_3006 + getForwardData_api,
      headers: headers,
    });

    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const createCirculation = async (params) => {
  const createCirculation_api = "/circulation";
  let result;

  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "post",
      url: process.env.REACT_APP_API_URL_3006 + createCirculation_api,
      headers: headers,
      data: params,
    });

    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const replyCirculation = async (circSeq, params) => {
  const replyCirculation_api = `/circulation/${circSeq}/messages`;
  let result;

  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "post",
      url: process.env.REACT_APP_API_URL_3006 + replyCirculation_api,
      headers: headers,
      data: params,
    });

    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const searchCirculation = async (params) => {
  const searchCirculation_api = `/circulation/search`;
  let result;

  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "post",
      url: process.env.REACT_APP_API_URL_3006 + searchCirculation_api,
      headers: headers,
      data: params,
      // data: {}
    });

    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const getCirculationReadStatus = async (circSeq) => {
  const getCirculationReadStatus_api = `/circulation/${circSeq}/recipients/read_status`;
  let result;

  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "get",
      url: process.env.REACT_APP_API_URL_3006 + getCirculationReadStatus_api,
      headers: headers,
    });

    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

export {
  getCirculation,
  getCirculationDetail,
  setCirculationReaded,
  getUser,
  getUserGroupType,
  getUserGroup,
  getForwardData,
  createCirculation,
  replyCirculation,
  searchCirculation,
  getCirculationReadStatus,
  recallCirculation,
};
